import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { InquiryService } from '../../services/inquiry.service'
import { ResolutionType, DataItem } from 'src/app/interface/ticket';
import { NzTableFilterList } from 'ng-zorro-antd/table';
import { TicketService } from 'src/app/services/ticket.service';
import { ActivatedRoute } from '@angular/router';
import { timeout } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { ApiAdapterService } from '../../services/api-adapter.service';
// import { Observable } from 'rxjs'; // Not used in current implementation

@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.component.html',
  styleUrls: ['./inquiry.component.css', './inquiry-loading-styles.css']
})
export class InquiryComponent implements OnInit, OnDestroy {
  @ViewChild('ticketInfomation') ticketInfomation: any;
  pageIndex: number = 1; //当前页面
  pageSize: number = 20; //当前页面数量
  loading: boolean = false; //是否加载中
  total: number = 0; //列表总数据
  ticketVisible: boolean = false; //是否打开ticket页面
  isDescriptionVisible: boolean = false; //列表下拉description状态显示
  isSubmittedDateVisible: boolean = false; //列表下拉SubmittedDate状态显示
  isClosedDateVisible: boolean = false; //列表下拉ClosedDate状态显示
  isAcceptDateVisible: boolean = false; //列表下拉AcceptDate状态显示
  isAcceptBySearch: boolean = false; //列表下拉isAcceptBySearch状态显示
  acceptBySearch: string = "";
  isSupport = false; //是否IT support
  ticketNo: string = "";
  ticketId: number = 0;
  ticketGuid: string = "";
  ticketStatus: string = "";
  categoryCode: string = "";
  subCategoryCode: string = "";
  description: string = "";
  keywords: string = "";  //关键词搜索
  categoryID: string | number = 0; //搜索categoryID, safe default to prevent undefined values, supports multiple selections
  ticketStatusID: string = "0";//搜索ticketStatusID
  isAddBtn:boolean = false;//点击新建按钮
  ticketStatusList: NzTableFilterList = [];
  originalTicketStatusList: NzTableFilterList = [];
  originalSupportTicketStatusList: NzTableFilterList = [];
  resolutionTypeID: number = 0;//搜索resolutionTypeID
  resolutionTypeList: ResolutionType[] = [];
  problemCategoryList: NzTableFilterList = [];
  ticketProblemCategoryList: any = [];
  supportTeamList: NzTableFilterList = [];
  MaskStyle: any = {
    "background": "rgba(0, 0, 0, 0.1)",
    "backdrop-filter": "blur(4px)",
  };
  lang = localStorage.getItem('lang') || 'en'; // ✅ Fix: Use localStorage instead of sessionStorage
  listOfData: any[] = [];
  submittedByName: string = "";
  acceptedByName: string = "";
  closedByName: string = "";
  isDescTicketNo: any = null;
  isDescFullName: any = null;
  isDescAcceptedBy: any = null;
  isDescSubmittedBy: any = null;
  isDescClosedBy: any = null;
  isDescAcceptedDate: any = null;
  isDescSubmittedDate: any = null;
  isDescClosedDate: any = null;
  submittedDate: Date[] = [];
  closedDate: Date[] = [];
  acceptDate: Date[] = [];

  // Enhanced Loading System Properties
  isLoadingTicket: boolean = false;
  loadingMessage: string = '';
  loadingSteps: string[] = [];
  currentLoadingStep: number = 0;
  loadingProgress: number = 0;
  loadingStartTime: number = 0;
  loadingTimer: any = null;
  ticketInfo: any = {};

  // Local Sorting Properties - Independent sort state for each column
  sortStates: {
    [key: string]: {
      column: string;
      order: 'asc' | 'desc' | null;
    };
  } = {
    ticketNo: { column: 'ticketNo', order: null },
    fullName: { column: 'fullName', order: null },
    submittedDate: { column: 'submittedDate', order: null },
    acceptBy: { column: 'acceptBy', order: null },
    acceptDate: { column: 'acceptDate', order: null },
    closedBy: { column: 'closedBy', order: null },
    closedDate: { column: 'closedDate', order: null }
  };
  originalData: any[] = [];
  userInfo = JSON.parse(localStorage.getItem("User") || '{}'); //获取当前登录用户信息，用于填充信息

  constructor(private translate: TranslateService, private inquiryService: InquiryService, private message: NzMessageService, private ticketService: TicketService,
    private activatedRoute: ActivatedRoute, private apiAdapter: ApiAdapterService) {
    // ✅ Subscribe to language changes to update categories reactively
    this.translate.onLangChange.subscribe((event: any) => {
      console.log('🌐 [Inquiry] Language changed to:', event.lang);
      this.lang = event.lang;
      localStorage.setItem('lang', event.lang);
      // Reload categories when language changes
      this.reloadCategories();
    });

    //通过email Link打开详情页面
    this.activatedRoute.queryParams.subscribe(
      (queryParams: any) => {
        console.log('🔍 [Inquiry] Query params received:', queryParams);

        if (queryParams.ticketId && !this.isLoadingTicket && !this.ticketVisible) {
          console.log('🎫 [Inquiry] Ticket ID from URL:', queryParams.ticketId);

          // Start enhanced loading only if not already loading
          this.startTicketLoading(queryParams.ticketId);
        }

        if(queryParams.description){
          console.log('📝 [Inquiry] Description from URL:', queryParams.description);
          this.description = queryParams.description;
        }
      }
    )

    this.activatedRoute.params.subscribe(
      (data: any) => {
        if (data.categoryCode) {
          if (data.subCategoryCode) {
            this.showNewTicket(data.categoryCode, data.subCategoryCode);
          } else {
            this.showNewTicket(data.categoryCode);
          }
        }
      }
    )
  }

  ngOnInit() {
    this.inquiryService.getTicketStatus().subscribe(
      {
        next: (list) => {
          console.log('🔍 Ticket status list received:', list.data);
          this.ticketStatusList = this.originalTicketStatusList = list.data.map((ticketStatus: { ticketStatusDescr: any; id: any; }) => {
            const item = {
              text: ticketStatus.ticketStatusDescr,
              value: ticketStatus.id
            };
            console.log('🔍 Creating status item:', item);
            return item;
          })
          this.originalSupportTicketStatusList = JSON.parse(JSON.stringify(this.ticketStatusList));
          console.log('🔍 Final status list:', this.ticketStatusList);
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )

    this.inquiryService.getProblemCategory().subscribe(
      {
        next: (list) => {
          this.ticketProblemCategoryList = list.data;
          this.problemCategoryList = list.data.map((problemCategory: { categoryDescrEng: any; categoryDescrChi: any; id: any; }) => {
            return {
              text: this.lang == "en" ? problemCategory.categoryDescrEng : problemCategory.categoryDescrChi,
              value: problemCategory.id
            }
          })
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )

    this.inquiryService.getResolutionTypeList().subscribe(
      {
        next: (list) => {
          this.resolutionTypeList = Array.isArray(list?.data) ? list.data : [];
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )
    this.inquiryService.getSupportTeam().subscribe(
      {
        next: (list) => {
          this.supportTeamList = list.data.map((team: { teamDescrEng: any; teamDescrChi: any; id: any; }) => {
            return {
              text: this.lang == "en" ? team.teamDescrEng : team.teamDescrChi,
              value: team.id
            }
          })
        },
        error: (error) => {
          console.error('error: ' + error);
        }
      }
    )

    // Check if current user is IT support
    if(this.userInfo?.isSupport || this.userInfo?.role == 'IT Support' || this.userInfo?.role == 'Admin'){
      this.isSupport = true;
    }

    // Load initial ticket list
    this.searchInquiryList(false);
  }

  // ✅ Method to reload categories when language changes
  reloadCategories(): void {
    console.log('🔄 [Inquiry] Reloading categories for language:', this.lang);
    this.inquiryService.getProblemCategory().subscribe(
      {
        next: (list) => {
          this.ticketProblemCategoryList = list.data;
          this.problemCategoryList = list.data.map((problemCategory: { categoryDescrEng: any; categoryDescrChi: any; id: any; }) => {
            return {
              text: this.lang == "en" ? problemCategory.categoryDescrEng : problemCategory.categoryDescrChi,
              value: problemCategory.id
            }
          })
          console.log('✅ [Inquiry] Categories reloaded with language:', this.lang);
        },
        error: (error) => {
          console.error('❌ [Inquiry] Error reloading categories:', error);
        }
      }
    );
  }

  searchInquiryList(resetPage: boolean = false) {
    this.loading = true;
    if (resetPage) {
      this.pageIndex = 1;
    }

    // Always perform local filtering to ensure it works
    this.performLocalSearch();
  }

  // Refresh data from server when search bar is empty
  GetTicketPage() {
    console.log('🔄 [Inquiry] GetTicketPage called - fetching fresh data from server');
    this.loading = true;
    this.pageIndex = 1;

    // Clear local cache to force fresh data fetch
    this.originalData = [];

    // Fetch fresh data from server
    this.apiAdapter.getTicketPage({
      page: 0,
      pageSize: 1000,
      keywords: '',
      filters: []
    }).subscribe({
      next: (data: any) => {
        console.log('✅ [Inquiry] Fresh data loaded from server:', data?.data?.length || 0, 'records');
        if (data && data.data) {
          this.originalData = data.data;
        } else {
          this.originalData = [];
        }
        // Apply filters after data is loaded
        this.applyLocalFilters();
      },
      error: (error: any) => {
        console.error('❌ [Inquiry] Failed to load data from server:', error);
        this.originalData = [];
        this.applyLocalFilters();
      }
    });
  }

  performLocalSearch(): void {
    console.log('🔍 Performing local filtering');

    // Check if data is available, if not load it first
    if (!this.originalData || this.originalData.length === 0) {
      console.log('🔍 No data available, loading from API...');
      this.inquiryService.getInquiryList({
        page: 0,
        pageSize: 1000, // Get all data for local filtering
        keywords: '',
        filters: []
      }).subscribe({
        next: (data: any) => {
          if (data && data.data && Array.isArray(data.data)) {
            console.log('🔍 Data loaded successfully, applying filters...');
            this.originalData = data.data;
            // Apply filters after data is loaded
            this.applyLocalFilters();
          } else {
            console.log('⚠️ No data returned from API or data is not array');
            this.originalData = [];
            this.applyLocalFilters();
          }
        },
        error: (error: any) => {
          console.error('❌ Failed to load initial data:', error);
          // Use empty data if API fails
          this.originalData = [];
          this.applyLocalFilters();
        }
      });
    } else {
      console.log('🔍 Data already loaded, applying filters immediately');
      // Data already loaded, apply filters immediately
      this.applyLocalFilters();
    }
  }

  applyLocalFilters(): void {
    console.log('🔍 Applying filters to', this.originalData?.length || 0, 'records');
    console.log('📋 Filter values - Status:', this.ticketStatusID, 'Category:', this.categoryID, 'Keywords:', this.keywords, 'AcceptBy:', this.acceptBySearch);

    // Check if data is available
    if (!this.originalData || this.originalData.length === 0) {
      console.log('⚠️ No data available for filtering');
      this.listOfData = [];
      this.total = 0;
      this.loading = false;
      return;
    }

    // Start with all data
    let filteredData = [...this.originalData];

    // Apply keyword filter
    if (this.keywords && this.keywords.trim() !== '') {
      const keyword = this.keywords.toLowerCase().trim();
      filteredData = filteredData.filter(item => {
        const ticketNoMatch = item.ticket?.ticketNo?.toLowerCase().includes(keyword);
        const descriptionMatch = item.ticket?.detail?.toLowerCase().includes(keyword);
        const fullNameMatch = item.submittedByName?.toLowerCase().includes(keyword) ||
                            item.ticket?.submittedBy?.toLowerCase().includes(keyword);
        return ticketNoMatch || descriptionMatch || fullNameMatch;
      });
    }

    // Apply status filter
    if (this.ticketStatusID !== "0" && this.ticketStatusID !== "") {
      const statusIds = this.ticketStatusID.split(',').map(id => {
        // Try to parse as number first
        const numId = parseInt(id);
        if (!isNaN(numId)) {
          return numId;
        }
        // Fallback to string value
        return id;
      }).filter(id => id !== undefined && id !== null && id !== '');

      if (statusIds.length > 0) {
        filteredData = filteredData.filter(item => {
          const ticketStatusID = item.ticket?.ticketStatusID;
          if (ticketStatusID === undefined || ticketStatusID === null) {
            return false;
          }

          // Check if ticketStatusID is a number or string and matches any of the filter values
          return statusIds.some(filterId => {
            if (typeof filterId === 'number' && typeof ticketStatusID === 'number') {
              return filterId === ticketStatusID;
            }
            if (typeof filterId === 'string' && typeof ticketStatusID === 'string') {
              return filterId === ticketStatusID;
            }
            if (typeof filterId === 'number' && typeof ticketStatusID === 'string') {
              return filterId.toString() === ticketStatusID;
            }
            if (typeof filterId === 'string' && typeof ticketStatusID === 'number') {
              return filterId === ticketStatusID.toString();
            }
            return false;
          });
        });
      }
    }

    // Apply category filter
    if (this.categoryID !== 0 && this.categoryID !== '') {
      // Handle multiple category selections (comma-separated values)
      const categoryFilterValue = this.categoryID.toString();
      const selectedCategories = categoryFilterValue.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));

      if (selectedCategories.length > 0) {
        filteredData = filteredData.filter(item => {
          const categoryID = item.ticket?.subCategory?.category?.id || 0;
          return selectedCategories.includes(categoryID);
        });
      }
    }

    // Apply acceptBy filter
    if (this.acceptBySearch && this.acceptBySearch.trim() !== '') {
      const acceptBy = this.acceptBySearch.toLowerCase().trim();
      filteredData = filteredData.filter(item => {
        const acceptedByName = item.acceptedByName?.toLowerCase() || '';
        const acceptedBy = item.ticket?.acceptedBy?.toLowerCase() || '';
        return acceptedByName.includes(acceptBy) || acceptedBy.includes(acceptBy);
      });
    }

    // Apply date range filters
    if (this.submittedDate && this.submittedDate.length == 2) {
      const startDate = this.submittedDate[0];
      const endDate = this.submittedDate[1];
      filteredData = filteredData.filter(item => {
        const submittedDate = item.ticket?.submittedDate || item.ticket?.createdDate;
        if (!submittedDate) return false;
        const date = new Date(submittedDate);
        return date >= startDate && date <= endDate;
      });
    }

    if (this.closedDate && this.closedDate.length == 2) {
      const startDate = this.closedDate[0];
      const endDate = this.closedDate[1];
      filteredData = filteredData.filter(item => {
        const closedDate = item.ticket?.closedDate;
        if (!closedDate) return false;
        const date = new Date(closedDate);
        return date >= startDate && date <= endDate;
      });
    }

    if (this.acceptDate && this.acceptDate.length == 2) {
      const startDate = this.acceptDate[0];
      const endDate = this.acceptDate[1];
      filteredData = filteredData.filter(item => {
        const acceptedDate = item.ticket?.acceptedDate;
        if (!acceptedDate) return false;
        const date = new Date(acceptedDate);
        return date >= startDate && date <= endDate;
      });
    }

    // Apply sorting if needed
    if (this.sortStates) {
      const sortColumn = Object.values(this.sortStates).find(state => state.order !== null)?.column;
      if (sortColumn) {
        const sortOrder = Object.values(this.sortStates).find(state => state.order !== null)?.order;
        if (sortOrder) {
          filteredData = [...filteredData].sort((a, b) => {
            switch (sortColumn) {
              case 'ticketNo':
                return this.sortAlphanumeric(a, b, sortOrder);
              case 'submittedDate':
                return this.sortDates(a, b, sortOrder, 'submittedDate' in a.ticket ? 'submittedDate' : 'createdDate');
              case 'closedDate':
                return this.sortDates(a, b, sortOrder, 'closedDate');
              case 'fullName':
                return this.sortAlphanumeric(a, b, sortOrder);
              case 'acceptBy':
                return this.sortAlphanumeric(a, b, sortOrder);
              case 'acceptDate':
                return this.sortDates(a, b, sortOrder, 'acceptDate');
              case 'closedBy':
                return this.sortAlphanumeric(a, b, sortOrder);
              default:
                return 0;
            }
          });
        }
      }
    }

    // Update total count
    this.total = filteredData.length;

    // Apply pagination - slice the data based on current page index and page size
    const startIndex = (this.pageIndex - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.listOfData = filteredData.slice(startIndex, endIndex);

    this.loading = false;

    console.log('🔍 Local filtering complete. Found', filteredData.length, 'records. Displaying', this.listOfData.length, 'records for page', this.pageIndex);
  }

  ngOnDestroy(): void {
    this.clearLoadingTimer();
  }

  close() {
    if ((this.ticketInfomation.ticketStatusID == 0 ? this.ticketInfomation.ticketForm.dirty : this.ticketInfomation.saveFromDirty() || this.ticketInfomation.isFileChange)) {
      this.ticketInfomation.back();
      if (!this.ticketInfomation.isBackConfirmClick) {
        return;
      }
    }
    this.ticketVisible = false;
    this.isAddBtn = false;
    if (this.ticketInfomation.isOperateAction) {
      this.searchInquiryList();
    }
  }

  showInfo(ticketInfo: any) {
    console.log('🎫 [Inquiry] Table row clicked - Opening ticket drawer:', ticketInfo);

    // Prevent multiple clicks while loading
    if (this.isLoadingTicket) {
      console.log('⚠️ [Inquiry] Already loading, ignoring click');
      return;
    }

    // Direct opening without loading animation for better UX
    console.log('🎫 [Inquiry] Opening ticket drawer directly');
    this.ticketVisible = true;
    this.ticketInfo = ticketInfo;
    this.ticketId = ticketInfo.ticket.id;
    this.ticketGuid = ticketInfo.ticket.guid;
  }

  showNewTicket(categoryCode: any, subCategoryCode?: any) {
    this.ticketVisible = true;
    this.categoryCode = categoryCode;
    this.subCategoryCode = subCategoryCode;
  }

  onFilterParamsChange(e: any, type: string): void {
    console.log('🔍 Filter change event - Type:', type, 'Value:', e, 'Type of e:', typeof e);
    console.log('🔍 Current filter state - Status:', this.ticketStatusID, 'Category:', this.categoryID, 'Keywords:', this.keywords, 'AcceptBy:', this.acceptBySearch);

    switch (type) {
      case 'status':
        console.log('🔍 Status filter change - Current value:', this.ticketStatusID);
        // Support 2 status lists separated
        if (this.isSupport) {
          this.ticketStatusList = this.originalSupportTicketStatusList;
        } else {
          this.ticketStatusList = this.originalTicketStatusList;
        }
        console.log('🔍 Status filter list:', this.ticketStatusList);
        // Handle filter change
        if (Array.isArray(e) && e.length > 0) {
          console.log('🔍 Status filter items:', e);
          console.log('🔍 First item:', e[0], 'Type:', typeof e[0]);
          console.log('🔍 First item value:', e[0]?.value, 'Type:', typeof e[0]?.value);

          // Try to get numeric values, fallback to string values if needed
          const selectedValues = e.map((item: any, index: number) => {
            console.log(`🔍 Processing item ${index}:`, item, 'Type:', typeof item);

            let value: any;
            // Try different ways to get the value
            if (item && item.value !== undefined) {
              value = item.value;
            } else if (item && typeof item === 'object' && 'id' in item) {
              value = item.id;
            } else {
              value = item;
            }

            console.log(`🔍 Extracted value:`, value, 'Type:', typeof value);

            // Check if value is already a number or can be converted to a number
            if (typeof value === 'number') {
              return value;
            }
            // Try to parse as integer
            const numValue = parseInt(value);
            if (!isNaN(numValue)) {
              return numValue;
            }
            // Fallback to string value
            return value;
          });
          this.ticketStatusID = selectedValues.join(',');
          console.log('🔍 New status filter value:', this.ticketStatusID);
        } else {
          this.ticketStatusID = "0";
          console.log('🔍 Status filter cleared');
        }
        break;
      case 'problemCategory':
        if (Array.isArray(e) && e.length > 0) {
          // Handle multiple category selections
          const selectedCategories: number[] = [];

          e.forEach((item: any, index: number) => {
            console.log(`🔍 Processing category item ${index}:`, item);

            let categoryId: any = 0;

            if (item && item.value !== undefined) {
              categoryId = item.value;
            } else if (item && typeof item === 'object' && 'id' in item) {
              categoryId = item.id;
            } else if (item) {
              categoryId = item;
            }

            // Convert to number if possible
            const numValue = parseInt(categoryId);
            if (!isNaN(numValue)) {
              selectedCategories.push(numValue);
            }
          });

          // Join multiple category IDs with comma for storage
          this.categoryID = selectedCategories.length > 0 ? selectedCategories.join(',') : 0;
          console.log('🔍 Updated category filter with multiple selections:', this.categoryID);
        } else {
          this.categoryID = 0;
        }
        break;
      case 'assignedTeam':
        if (Array.isArray(e) && e.length > 0) {
          this.keywords = e[0].value;
        } else {
          this.keywords = "";
        }
        break;
      case 'acceptBy':
        if (Array.isArray(e) && e.length > 0) {
          this.acceptBySearch = e[0].value;
        } else {
          this.acceptBySearch = "";
        }
        break;
    }
    // Force update the filter value binding by triggering change detection
    this.ticketStatusID = this.ticketStatusID;
    console.log('🔍 Final filter state - Status:', this.ticketStatusID);
    console.log('🔍 Triggering search with reset:', true);
    this.searchInquiryList(true);
  }

  onSortParamsChange(e: any, type: string) {
    console.log('🔽 SORT CLICKED - Event:', e);
    console.log('🔽 SORT CLICKED - Type:', type);
    console.log('🔽 SORT CLICKED - Event value:', e?.value);
    console.log('🔽 SORT CLICKED - Event value type:', typeof e?.value);
    console.log('🔽 SORT CLICKED - Event value string:', e?.value?.toString());

    // Handle three states: "ascend" (true), "descend" (false), null (no sorting)
    let sortOrder: 'asc' | 'desc' = 'asc'; // Default sort order

    // Check if e.value exists and is a valid sort direction
    if (e && e.value !== undefined) {
      if (e.value === "ascend") {
        sortOrder = 'asc';
        console.log('🔽 SORT CLICKED - Setting sortOrder to asc');
      } else if (e.value === "descend") {
        sortOrder = 'desc';
        console.log('🔽 SORT CLICKED - Setting sortOrder to desc');
      } else {
        sortOrder = 'asc'; // No sorting
        console.log('🔽 SORT CLICKED - Setting sortOrder to null (no sort)');
      }
    } else {
      // If e.value is undefined, toggle the sort order based on current state
      if (this.sortStates[type].column === type) {
        // Toggle between asc, desc, and null
        if (this.sortStates[type].order === 'asc') {
          sortOrder = 'desc';
          console.log('🔽 SORT CLICKED - Toggling from asc to desc');
        } else if (this.sortStates[type].order === 'desc') {
          sortOrder = 'asc';
          console.log('🔽 SORT CLICKED - Toggling from desc to no sort');
        } else {
          sortOrder = 'asc';
          console.log('🔽 SORT CLICKED - Setting initial sortOrder to asc');
        }
      } else {
        // New column, default to asc
        sortOrder = 'asc';
        console.log('🔽 SORT CLICKED - New column, setting sortOrder to asc');
      }
    }

    console.log('🔽 SORT CLICKED - Final computed sortOrder:', sortOrder);

    // Update sort state for the specific column
    this.sortStates[type] = {
      column: type,
      order: sortOrder
    };

    console.log('✅ Set sortState for', type, '=', this.sortStates[type]);

    // Perform local sorting
    this.performLocalSort(type, sortOrder);
  }

  addTicket() {
    this.categoryCode = "";
    this.subCategoryCode = "";
    this.ticketId = 0;
    this.ticketGuid = "";
    this.ticketStatus = "";
    this.description = "";
    this.isAddBtn = true;
    this.ticketVisible = true;
  }

  getStatus(statusID: any) {
    if (this.ticketStatusList) {
      const ticketStatus = this.ticketStatusList.find((item: { value: any; }) => item.value == statusID);
      return ticketStatus ? ticketStatus.text : statusID;
    }
    return statusID;
  }

  // Local Sorting Utility Functions
  sortAlphanumeric(a: any, b: any, order: 'asc' | 'desc'): number {
    const valueA = a.ticket?.ticketNo || '';
    const valueB = b.ticket?.ticketNo || '';
    const comparison = valueA.localeCompare(valueB, undefined, { sensitivity: 'case' });
    return order === 'asc' ? comparison : -comparison;
  }

  sortDates(a: any, b: any, order: 'asc' | 'desc', dateField: string): number {
    const dateA = this.parseDate(a.ticket?.[dateField]);
    const dateB = this.parseDate(b.ticket?.[dateField]);

    if (!dateA && !dateB) return 0;
    if (!dateA) return order === 'asc' ? 1 : -1;
    if (!dateB) return order === 'asc' ? -1 : 1;

    const comparison = dateA.getTime() - dateB.getTime();
    return order === 'asc' ? comparison : -comparison;
  }

  parseDate(dateString: string | undefined): Date | null {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  }

  performLocalSort(column: string, order: 'asc' | 'desc' | null): void {
    if (!order || !column) {
      this.listOfData = [...this.originalData];
      return;
    }

    const sortedData = [...this.originalData].sort((a, b) => {
      switch (column) {
        case 'ticketNo':
          return this.sortAlphanumeric(a, b, order);
        case 'submittedDate':
          return this.sortDates(a, b, order, 'submittedDate' in a.ticket ? 'submittedDate' : 'createdDate');
        case 'closedDate':
          return this.sortDates(a, b, order, 'closedDate');
        case 'fullName':
          return this.sortAlphanumeric(a, b, order);
        case 'acceptBy':
          return this.sortAlphanumeric(a, b, order);
        case 'acceptDate':
          return this.sortDates(a, b, order, 'acceptDate');
        case 'closedBy':
          return this.sortAlphanumeric(a, b, order);
        default:
          return 0;
      }
    });

    this.listOfData = sortedData;
  }

  // Enhanced Loading System Methods
  startTicketLoading(ticketId: string): void {
    // Prevent multiple loading operations
    if (this.isLoadingTicket) {
      console.log('⚠️ [Inquiry] Loading already in progress, ignoring request');
      return;
    }

    console.log('🚀 [Inquiry] Starting enhanced ticket loading for ID:', ticketId);

    this.isLoadingTicket = true;
    this.loadingStartTime = Date.now();
    this.loadingProgress = 0;
    this.currentLoadingStep = 0;
    this.loadingMessage = 'Initializing ticket loading...';

    // Clear any existing timer
    this.clearLoadingTimer();

    this.loadingSteps = [
      '🔍 Validating ticket ID...',
      '🔐 Checking authentication...',
      '📡 Connecting to backend server...',
      '🎫 Fetching ticket information...',
      '👤 Verifying user permissions...',
      '🖥️ Loading VDI approval status (if applicable)...',
      '📋 Preparing ticket display...'
    ];

    this.executeLoadingSteps(ticketId);
  }

  executeLoadingSteps(ticketId: string): void {
    console.log('📋 [Inquiry] Executing loading steps for ticket:', ticketId);

    const stepDelay = 800; // Delay between steps for visual effect

    const executeNextStep = () => {
      if (this.currentLoadingStep < this.loadingSteps.length) {
        this.loadingMessage = this.loadingSteps[this.currentLoadingStep];
        this.loadingProgress = Math.round(((this.currentLoadingStep + 1) / this.loadingSteps.length) * 90);
        this.currentLoadingStep++;

        console.log(`📊 [Inquiry] Step ${this.currentLoadingStep}/${this.loadingSteps.length}: ${this.loadingMessage}`);

        this.loadingTimer = setTimeout(executeNextStep, stepDelay);
      } else {
        // Final step: actually load the ticket data
        this.loadTicketData(ticketId);
      }
    };

    executeNextStep();
  }

  loadTicketData(ticketId: string): void {
    console.log('🎫 [Inquiry] Loading ticket data for ID:', ticketId);

    // Set final loading state
    this.loadingMessage = '🔄 Loading ticket details...';
    this.loadingProgress = 95;

    // Call the original ticket loading logic
    this.ticketId = parseInt(ticketId);

    // Use the ticket service to get ticket data
    this.ticketService.getTicketInfo(ticketId).pipe(
      timeout(30000) // 30 second timeout
    ).subscribe({
      next: (ticketData: any) => {
        console.log('✅ [Inquiry] Ticket data loaded successfully:', ticketData);
        this.handleTicketLoadingSuccess(true, ticketData);
      },
      error: (error: any) => {
        console.error('❌ [Inquiry] Error loading ticket:', error);
        this.handleTicketLoadingSuccess(false, null);

        // Show error message
        this.loadingMessage = `❌ Error loading ticket: ${error.message || 'Unknown error'}`;

        // Reset loading state after error
        setTimeout(() => {
          this.isLoadingTicket = false;
          this.loadingMessage = '';
        }, 3000);
      }
    });
  }

  handleTicketLoadingSuccess(success: boolean, ticketData: any): void {
    console.log('🎯 [Inquiry] Handling ticket loading result:', { success, ticketData });

    this.loading = false;
    this.isLoadingTicket = false;

    const loadingTime = Date.now() - this.loadingStartTime;
    console.log(`⏱️ [Inquiry] Total loading time: ${loadingTime}ms`);

    if (success && ticketData) {
      this.loadingMessage = '✅ Ticket loaded successfully!';
      this.showInfo(ticketData);

      // Clear success message after a delay
      setTimeout(() => {
        this.loadingMessage = '';
      }, 2000);
    } else {
      this.loadingMessage = '';
    }
  }

  getLoadingPercentage(): number {
    return Math.min(this.loadingProgress, 100);
  }

  isCurrentlyLoading(): boolean {
    return this.isLoadingTicket;
  }

  getLoadingTime(): string {
    if (!this.loadingStartTime) return '0s';
    const elapsed = Math.floor((Date.now() - this.loadingStartTime) / 1000);
    return `${elapsed}s`;
  }

  completeTicketLoading(): void {
    console.log('✅ [Inquiry] Ticket loading completed');
    this.isLoadingTicket = false;
    this.loadingMessage = 'Loading completed!';
    this.loadingProgress = 100;

    // Clear loading after a short delay
    setTimeout(() => {
      this.isLoadingTicket = false;
      this.loadingMessage = '';
    }, 1000);
  }

  cancelLoading(): void {
    console.log('❌ [Inquiry] Loading cancelled');
    this.isLoadingTicket = false;
    this.loadingMessage = '';
    this.loadingProgress = 0;
    this.currentLoadingStep = 0;
  }

  clearLoadingTimer(): void {
    if (this.loadingTimer) {
      clearTimeout(this.loadingTimer);
      this.loadingTimer = null;
    }
  }

  // VDI Category Detection (for filter-based column visibility)
  isVDICategorySelected(): boolean {
    // Check if VDI category is selected in filters
    const vdiCategory = this.ticketProblemCategoryList.find((cat: any) =>
      cat.categoryDescrEng?.toLowerCase().includes('vdi') ||
      cat.categoryDescrChi?.includes('VDI')
    );
    return this.categoryID === vdiCategory?.id;
  }

  // Check if a specific ticket is an Azure VDI ticket (for per-ticket column visibility)
  isAzureVDITicket(ticket: any): boolean {
    const categoryDescrEng = ticket?.subCategory?.category?.categoryDescrEng || '';
    const categoryDescrChi = ticket?.subCategory?.category?.categoryDescrChi || '';
    return categoryDescrEng.toLowerCase().includes('azure vdi') ||
           categoryDescrChi.includes('Azure VDI') ||
           categoryDescrChi.includes('VDI');
  }

  // VDI Status Color Mapping
  getVDIStatusColor(status: string): string {
    const statusMap: { [key: string]: string } = {
      'Pending': 'orange',
      'Approved': 'green',
      'Rejected': 'red',
      'InProgress': 'blue',
      'Completed': 'green',
      'Failed': 'red'
    };
    return statusMap[status] || 'default';
  }
}